module.exports = __webpack_public_path__ + "static/media/lampe.b157bfc2.png";